export default __webpack_public_path__ + "static/media/15.65f9d8a3.png";